import React, { createContext, useEffect, useState } from 'react';
import Util from '../core/Util';
import Api from '../core/api';

const AuthContext = createContext({ list: [] });

export const AuthProvider = ({ children }) => {

    const [isLogged, setIsLogged] = useState(false);
    const [language, setLanguage] = useState('pt');
    const [user, setUser] = useState({ name: '', email: '', role: '' });

    async function handleLogout() {
        Util.removeToken();
        setIsLogged(false);
        Util.redirect();
    }

    async function getUser() { 
        const response = await Api('post', 'me', '', {});
        setUser(response);
    }

    useEffect(() => {

        if(Util.getToken()) {
            setIsLogged(true);
            getUser();
        }

        if(localStorage.getItem('language@app')) {
            setLanguage(localStorage.getItem('language@app'));
        } else {
            localStorage.setItem('language@app', 'pt');
        }

    }, []);




    return (
        <AuthContext.Provider value={{ 
            isLogged,
            setIsLogged,
            language,
            setLanguage,
            handleLogout,
            user,
            setUser
        }}>
            {children}
        </AuthContext.Provider>
    )
}

export default AuthContext;
